"use strict";

var AddressSuggestionService = function(locationSelector, zipCodeSelector, streetSelector, countryCodeSelector, type) {

    var suggestionPopupSelector = '#suggestionPopup-' + type;
    var suggestionListSelector = '#suggestion-list-' + type;
    var suggestionListItemSelector = '#suggestion-list-' + type + ' li';
    var suggestionItemTemplateSelector = '#suggestion-li-template-' + type;
    var suggestionNoResultsSelector = '#suggestion-no-results-' + type;

    var data = {
        "location" : {
            id : 'location',
            selector : locationSelector,
            timer : undefined,
            timeoutValue : 500,
            textHolder : undefined,
            textHolderReset : false,
            searchTextMinLength : 3,
            suggestionList : undefined,
            selectedSuggestion : {
                name : undefined,
                administrativeLevels : undefined
            },
            suggestionSearchUrl : '/suggestion-location-ajax',
            getAjaxRequestData : getAjaxRequestLocationData,
            getSuggestionName : getLocationSuggestionName,
            getSuggestionAdministrativeLevels : getLocationSuggestionAdministrativeLevels
        },
        "zipcode" : {
            id : 'zipcode',
            selector : zipCodeSelector,
            timer : undefined,
            timeoutValue : 100,
            textHolder : undefined,
            textHolderReset : false,
            searchTextMinLength : 1,
            suggestionList : undefined,
            selectedSuggestion : {
                name : undefined
            },
            suggestionSearchUrl : '/suggestion-zipcode-ajax',
            getAjaxRequestData : getAjaxRequestZipCodeData,
            getSuggestionName : getZipCodeSuggestionName
        },
        "street" : {
            id : 'street',
            selector : streetSelector,
            timer : undefined,
            timeoutValue : 500,
            textHolder : undefined,
            textHolderReset : false,
            searchTextMinLength : 3,
            suggestionList : undefined,
            selectedSuggestion : {
                name : undefined
            },
            suggestionSearchUrl : '/suggestion-street-ajax',
            getAjaxRequestData : getAjaxRequestStreetData,
            getSuggestionName : getStreetSuggestionName
        }
    };

    var locationData = data['location'];
    var zipCodeData = data['zipcode'];
    var streetData = data['street'];
    var countryCodeSel = countryCodeSelector;

    window.THEME.$document.on('countryChangedEvent', function(){
        Object.keys(data).forEach(function(key) {
            data[key].textHolderReset = true;
        });
    });

    /*LOCATION*/
    function handleLocationFieldKeyUp() {
        handleFieldKeyUp($(locationData.selector), locationData);
    }

    function handleLocationFieldFocus() {
        handleFieldFocus(locationData);
    }

    function handleLocationFieldFocusOut() {
        handleFieldFocusOut(locationData);
    }

    function getAjaxRequestLocationData(searchText) {
        searchText = encodeURIComponent(searchText)
        var ajaxRequestData = {
            'location-prefix' : searchText
        };
        var countryCode = getCountryCode();
        if (countryCode) {
            ajaxRequestData['country-code'] = countryCode;
        }
        if (streetData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['street'] = encodeURIComponent(streetData.selectedSuggestion.name);
        }
        if (zipCodeData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['zipcode'] = zipCodeData.selectedSuggestion.name;
        }
        return ajaxRequestData;
    }

    function getAjaxRequestLocationAdministrativeLevelsData() {
        var ajaxAdministrativeLevels = {};
        if (locationData.selectedSuggestion.administrativeLevels !== undefined) {
            Object.keys(locationData.selectedSuggestion.administrativeLevels).sort().forEach(function(level) {
                ajaxAdministrativeLevels['administrativeLevel' + level] = locationData.selectedSuggestion.administrativeLevels[level];
            });
        }
        return ajaxAdministrativeLevels;
    }

    function getLocationSuggestionName(suggestion) {
        return suggestion["locationName"];
    }

    function getLocationSuggestionAdministrativeLevels(suggestion) {
        var administrativeLevels = "";
        var administrativeLevelsMap = suggestion["administrativeLevels"];
        Object.keys(administrativeLevelsMap).sort().forEach(function(level) {
            administrativeLevels += (administrativeLevelsMap[level] + ", ");
        });
        if (administrativeLevels.length > 0) {
            administrativeLevels = "(" + administrativeLevels.substring(0, administrativeLevels.length - 2) + ")";
        }
        return administrativeLevels;
    }

    /*ZIP CODE*/
    function handleZipCodeFieldKeyUp() {
        handleFieldKeyUp($(zipCodeData.selector), zipCodeData);
    }

    function handleZipCodeFieldFocus() {
        handleFieldFocus(zipCodeData);
    }

    function handleZipCodeFieldFocusOut() {
        handleFieldFocusOut(zipCodeData);
    }

    function getAjaxRequestZipCodeData(searchText) {
        var ajaxRequestData = {
            'zipcode-prefix' : searchText
        };
        var countryCode = getCountryCode();
        if (countryCode) {
            ajaxRequestData['country-code'] = countryCode;
        }
        if (locationData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['location'] = encodeURIComponent(locationData.selectedSuggestion.name);
            $.extend(ajaxRequestData, getAjaxRequestLocationAdministrativeLevelsData());
        }
        if (streetData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['street'] = encodeURIComponent(streetData.selectedSuggestion.name);
        }
        return ajaxRequestData;
    }

    function getZipCodeSuggestionName(suggestion) {
        return suggestion;
    }

    /*STREET*/
    function handleStreetFieldKeyUp() {
        handleFieldKeyUp($(streetData.selector), streetData);
    }

    function handleStreetFieldFocus() {
        handleFieldFocus(streetData);
    }

    function handleStreetFieldFocusOut() {
        handleFieldFocusOut(streetData);
    }

    function getAjaxRequestStreetData(searchText) {
        searchText = encodeURIComponent(searchText)
        var ajaxRequestData = {
            'street-substring' : searchText
        };
        var countryCode = getCountryCode();
        if (countryCode) {
            ajaxRequestData['country-code'] = countryCode;
        }
        if (locationData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['location'] = encodeURIComponent(locationData.selectedSuggestion.name);
            $.extend(ajaxRequestData, getAjaxRequestLocationAdministrativeLevelsData());
        }
        if (zipCodeData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['zipcode'] = zipCodeData.selectedSuggestion.name;
        }
        return ajaxRequestData;
    }

    function getStreetSuggestionName(suggestion) {
        return suggestion;
    }

    /*HELPERS*/
    var clearData = function(data) {
        updateTextHolder(data, undefined);
        data.suggestionList = undefined;
        data.selectedSuggestion.name = undefined;
        if ('administrativeLevels' in data.selectedSuggestion) {
            data.selectedSuggestion.administrativeLevels = undefined;
        }
    };

    var handleFieldFocus = function(data) {
        if (!data.textHolderReset && (data.textHolder !== undefined) && (data.textHolder.length > 0)) {
            if ($(data.selector).val() === data.textHolder) {
                populateSuggestionPopup(data.suggestionList, data);
            } else {
                handleFieldKeyUp($(data.selector), data);
            }
        } else {
            handleFieldKeyUp($(data.selector), data);
        }
    };

    var handleFieldFocusOut = function(data) {
        var searchText = $(data.selector).val();
        if ((searchText !== undefined) && (searchText.length > 0) && !isEmptyList(data.suggestionList)) {
            searchText = searchText.toLowerCase();
            for (var i = 0; i < data.suggestionList.length; i++) {
                var suggestionName = data.getSuggestionName(data.suggestionList[i]);
                if (searchText === suggestionName.toLowerCase()) {
                    data.selectedSuggestion.name = suggestionName;
                    $(data.selector).val(suggestionName).trigger('keyup');
                    break;
                }
            }
        }
    };

    var handleFieldKeyUp = function($this, data) {
        var searchText = $this.val();
        clearTimeout(data.timer);
        if (searchText.length >= data.searchTextMinLength && (data.textHolderReset || data.textHolder !== searchText)) {
            data.timer = setTimeout(function() {
                if (data.selectedSuggestion.name !== undefined && data.selectedSuggestion.name !== searchText) {
                    data.selectedSuggestion.name = undefined;
                    if ('administrativeLevels' in data.selectedSuggestion) {
                        data.selectedSuggestion.administrativeLevels = undefined;
                    }
                }
                triggerSuggestionSearch(searchText, data);
            }, data.timeoutValue);
        } else if (searchText.length < data.searchTextMinLength) {
            clearData(data);
            $(suggestionPopupSelector).hide();
            clearPopupItems($(suggestionListItemSelector));
            $(suggestionListSelector).empty();
        }
    };

    var triggerSuggestionSearch = function(searchText, data) {
        if (data.selectedSuggestion.name !== undefined && data.selectedSuggestion.name !== searchText) {
            data.selectedSuggestion.name = undefined;
            if ('administrativeLevels' in data.selectedSuggestion) {
                data.selectedSuggestion.administrativeLevels = undefined;
            }
        }

        $.ajax({
            method: "GET",
            url: data.suggestionSearchUrl,
            data: data.getAjaxRequestData(searchText)
        }).done(function (ajaxSuggestionList) {
            updateTextHolder(data, searchText);
            data.suggestionList = ajaxSuggestionList;
            populateSuggestionPopup(ajaxSuggestionList, data);
        });
    };

    var populateSuggestionPopup = function(suggestionList, data) {
        var $popup = $(suggestionPopupSelector);
        var $suggestionResultsList = $(suggestionListSelector);
        var $templateElement = $(suggestionItemTemplateSelector);
        var templateHtml = $templateElement.html();
        var listHtml = $(suggestionNoResultsSelector).html();

        if (!templateHtml) {
            return;
        }

        $suggestionResultsList.empty();
        if (!isEmptyList(suggestionList)) {
            listHtml = "";
            for (var i = 0; i < suggestionList.length; i++) {
                listHtml += templateHtml
                    .replace(/{{index}}/g, i)
                    .replace(/{{name}}/g, data.getSuggestionName(suggestionList[i]))
                    .replace(/{{administrativeNames}}/g, 'getSuggestionAdministrativeLevels' in data ? data.getSuggestionAdministrativeLevels(suggestionList[i]): '');
            }
        }

        $suggestionResultsList.html(listHtml);
        $suggestionResultsList.data('suggestion-type', data.id);
        var $popupItems = $(suggestionListItemSelector);
        $popupItems.each(function(){
            $(this).on("click", function() {
                onSelectSuggestion($(this), data);
            });
        });
        $popup.insertAfter($(data.selector)).show();
        showPopupForSelectedField($(data.selector));
    };

    var onSelectSuggestion = function(suggestion, data) {
        var suggestionName = suggestion.find("span")[0].textContent;
        var suggestionIndex = suggestion.find("input")[0].value;

        updateTextHolder(data, suggestionName);
        data.selectedSuggestion.name = suggestionName;
        if ('administrativeLevels' in data.selectedSuggestion) {
            data.selectedSuggestion.administrativeLevels = data.suggestionList[suggestionIndex].administrativeLevels;
        }

        $(data.selector).val(suggestionName).trigger('keyup');
    };

    var isEmptyList = function(ajaxList) {
        return (ajaxList === undefined || ajaxList.length <= 0);
    };

    function togglePopup(event) {
        var $locationField = $(locationData.selector);
        var $zipcodeField = $(zipCodeData.selector);
        var $streetField = $(streetData.selector);
        var $popup = $(suggestionPopupSelector);

        if ($popup.is(":visible")) {
            if ((!$locationField.is(event.target) && $locationField.has(event.target).length === 0) &&
                (!$zipcodeField.is(event.target) && $zipcodeField.has(event.target).length === 0) &&
                (!$streetField.is(event.target) && $streetField.has(event.target).length === 0)) {
                $popup.hide();
            }
        }
    }

    var clearPopupItems = function($popupItems) {
        $popupItems.removeData("selected");
        $popupItems.removeClass("hover");
    };

    var selectItem = function($correctLi) {
        $correctLi.data("selected", true);
        $correctLi.addClass("hover");
    };

    var findSelected = function($popupItems) {
        var $toReturn = undefined;
        $popupItems.each(function() {
            if ($(this).data('selected')) {
                $toReturn = $(this);
            }
        });
        return $toReturn;
    };

    var findCorrectSelectedLi = function($popupItems, next) {
        var $foundSelected = findSelected($popupItems);
        if (typeof $foundSelected === "undefined") {
            return $popupItems.first();
        }

        if (next) {
            return $foundSelected.next();
        } else {
            return $foundSelected.prev();
        }
    };

    function togglePopupSelect(event) {
        var $popup = $(suggestionPopupSelector);
        var $popupList = $(suggestionListSelector);
        var $popupItems = $(suggestionListItemSelector);
        var $correctLi;
        var $selectedLi;

        if ($popup.is(":visible")) {
            switch (event.key) {
                case "ArrowDown":
                    $correctLi = findCorrectSelectedLi($popupItems, true);
                    clearPopupItems($popupItems);
                    selectItem($correctLi);
                    scrollPopup($correctLi, $popupList);
                    event.preventDefault();
                    break;
                case "ArrowUp":
                    $correctLi = findCorrectSelectedLi($popupItems, false);
                    clearPopupItems($popupItems);
                    selectItem($correctLi);
                    scrollPopup($correctLi, $popupList);
                    event.preventDefault();
                    break;
                case "Enter":
                    $selectedLi = findSelected($popupItems);
                    onSelectSuggestion($selectedLi, data[$popupList.data('suggestion-type')]);
                    $popup.hide();
                    event.preventDefault();
                    break;
                case "Escape":
                    $popup.hide();
                    clearPopupItems($popupItems);
                    event.preventDefault();
                    break;
            }
        }
    }

    var scrollPopup = function($correctLi, $popupList) {
        var itemPosition = $correctLi.position();
        if (itemPosition !== undefined) {
            $popupList.scrollTop($popupList.scrollTop() + itemPosition.top - $popupList.height()/2 + $correctLi.height()/2);
        }
    };

    var showPopupForSelectedField = function($selectedField){
        $selectedField.parent().css({
            position: "relative"
        });
        var pos = $selectedField.position();

        if ($(suggestionListSelector).text().length > 0){
            $(suggestionPopupSelector).css({
                position: "absolute",
                left: (pos.left + parseInt($selectedField.css('marginLeft'), 10)) + "px",
                top: ($selectedField.outerHeight() + $selectedField.position().top) + "px",
                width: $selectedField.outerWidth() + "px"
            });
        }
    };

    var getCountryCode = function() {
        var countryCode;
        if (countryCodeSel) {
            countryCode = $(countryCodeSel).val();
        } else {
            countryCode = undefined;
        }
        return countryCode;
    };

    var updateTextHolder = function(localData, text) {
        localData.textHolderReset = false;
        if (localData.textHolder !== text) {
            localData.textHolder = text;
            Object.keys(data).forEach(function(key) {
                if (key !== localData.id) {
                    data[key].textHolderReset = true;
                }
            });
        }
    };

    return {
        handleLocationFieldKeyUp: handleLocationFieldKeyUp,
        handleLocationFieldFocus: handleLocationFieldFocus,
        handleLocationFieldFocusOut: handleLocationFieldFocusOut,
        handleZipCodeFieldKeyUp: handleZipCodeFieldKeyUp,
        handleZipCodeFieldFocus: handleZipCodeFieldFocus,
        handleZipCodeFieldFocusOut: handleZipCodeFieldFocusOut,
        handleStreetFieldKeyUp: handleStreetFieldKeyUp,
        handleStreetFieldFocus: handleStreetFieldFocus,
        handleStreetFieldFocusOut: handleStreetFieldFocusOut,
        togglePopup: togglePopup,
        togglePopupSelect: togglePopupSelect
    };
};